module.exports = __webpack_public_path__ + "74ffe0d0ac23fd51d476f34a0451a864.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-27.png
// module id = 3255
// module chunks = 0